module.exports = __webpack_public_path__ + "img/trevor.892fa010.png";